import TYPES from '../product-types';
import { DIR } from 'core/constants';
import Copy from '@resn/gozer-core/copy';

export default [
    // XS1 ACCESSORIES
    // Hiding smartpuck for now
    // {
    //     id: 'xs1-smartpuck',
    //     type: TYPES.XS1_ACCESSORY,
    //     title: Copy.get('xs1-configurator-accessory-subtitle'),
    //     desc: Copy.get('xs1-configurator-accessory-bodycopy'),
    //     // remove cart
    //     // cartTitle: Copy.get('cart-xs1-item-smart-puck'),
    //     // cartDesc: Copy.get('cart-xs1-item-smart-puck-desc'),
    //     // cartImage: `${DIR.IMG}products/cart/smart-puck.jpg`,
    //     available: true,
    //     thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessories-image.png`],
    // },
    {
        id: 'xs1-accessory-tree',
        type: TYPES.XS1_ACCESSORY,
        title:  Copy.get('xs1-configurator-accessory-tree-subtitle'),
        desc: Copy.get('xs1-configurator-accessory-tree-bodycopy'),
        available: true,
        thumbs: [`${DIR.IMG}products/xs1/xs1-panel-accessory-tree-small.png`],
    },
];
